import { ethers } from "ethers";
import config from "../config";
import honeyabi from "../abis/honey.json";
import { Base20 } from "./Base20";

class HoneyDContract extends Base20 {
    constructor(signer: ethers.Signer | ethers.providers.Provider) {
        super(config.honeyAddress, honeyabi, signer);
    }
}

export default HoneyDContract;